import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { RestaurantServiceService } from '../../restaurant/restaurant-service.service';

@Component({
  selector: 'app-add-restaurant-type',
  templateUrl: './add-restaurant-type.component.html',
  styleUrls: ['./add-restaurant-type.component.scss']
})
export class AddRestaurantTypeComponent implements OnInit {
  model: any = {};

  constructor(
    private restaurantServices: RestaurantServiceService,
    private toastr: ToastrService,
    private router: Router,
  ) { }

  ngOnInit() {
  }
  onSubmit() {
    debugger;
      this.restaurantServices.CreateResturantType(this.model).subscribe((Data: any) => {
        if (!Data.id) {
          this.toastr.success('Successfully Added');
          this.router.navigateByUrl('/restaurantType');
        }
      }, error => {
        this.toastr.error(error.error.Message);
      });
    }
}
